declare namespace $ {

	type $mol_paragraph__title_bog_blitz_lobby_game_leaderboard_row_1 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_leaderboard_row['rank_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_game_leaderboard_row_2 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_leaderboard_row['name'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_paragraph__title_bog_blitz_lobby_game_leaderboard_row_3 = $mol_type_enforce<
		ReturnType< $bog_blitz_lobby_game_leaderboard_row['score_text'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	export class $bog_blitz_lobby_game_leaderboard_row extends $mol_view {
		rank_text( ): string
		Rank( ): $mol_paragraph
		Name( ): $mol_paragraph
		score_text( ): string
		Score( ): $mol_paragraph
		rank( ): number
		name( ): string
		score( ): number
		mine( ): boolean
		rank_medal( ): string
		attr( ): ({ 
			'data-mine': ReturnType< $bog_blitz_lobby_game_leaderboard_row['mine'] >,
			'data-medal': ReturnType< $bog_blitz_lobby_game_leaderboard_row['rank_medal'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=row.view.tree.d.ts.map